<template>
<v-app>
  <v-content>
    <router-view @progress="progressDialog" @toast="toast" />
  </v-content>
  <ProgressBar :visible="progressDialogVisible"></ProgressBar>
  <Toast :text.sync="toastText" :timeout="toastTimeout"></Toast>
</v-app>
</template>

<script>
import ProgressBar from '@/components/utils/ProgressBar'
import Toast from '@/components/utils/Toast'

export default {
  name: 'app',
  components: {
    ProgressBar,
    Toast
  },
  data() {
    return {
      progressDialogVisible: false,
      toastText: '',
      toastTimeout: 3000
    }
  },
  methods: {
    progressDialog(visible) {
      this.progressDialogVisible = visible;
    },
    toast(text, timeout) {
      if (timeout) this.toastTimeout = timeout;
      this.toastText = text;
    },
    on(ref, target) {
      this.$db.ref(ref).on('child_added', snapshot => this.$set(target, snapshot.key, snapshot.val()));
      this.$db.ref(ref).on('child_changed', snapshot => this.$set(target, snapshot.key, snapshot.val()));
      this.$db.ref(ref).on('child_removed', snapshot => this.$delete(target, snapshot.key));
    },
    off(ref) {
      this.$db.ref(ref).off();
    }
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (this.$root.userAuth) {
        let uid = this.$root.userAuth.uid;
        this.off(`userPie/${uid}`);
        this.off(`userPieOnline/${uid}`);
        this.$root.userDevice = {};
        this.$root.userDeviceOnline = {};
      }
      if (user) {
        user.getIdToken().then(token => console.log(token));
        this.$root.userAuth = user;
        this.on(`userPie/${user.uid}`, this.$root.userDevice);
        this.on(`userPieOnline/${user.uid}`, this.$root.userDeviceOnline);

        this.$root.userDeviceLoading = true;
        this.$db.ref(`userPie/${user.uid}`).once('value', () => {
          this.$root.userDeviceLoading = false;
        });

      } else {
        this.$root.userAuth = {};
      }
    })
  }
}
</script>
